module.exports = ($scope, $uibModalInstance, $http, endpoints) ->
  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  # Authenticate with Factiva
  $scope.login = ->
    $scope.factivaLogin.busy = true
    $scope.factivaLogin.status = ""

    $http.post(endpoints.ExternalFactivaSession,
      "Namespace": $scope.factivaLogin.namespace
      "Password": $scope.factivaLogin.password
      "UserId": $scope.factivaLogin.username
      "Parts": "EncryptedToken"
    , {
      "headers": {"X-Requested-With": undefined}
    }).success((data, status, headers, config) ->
      token = data.EncryptedToken
      if token
        $scope.sendToken(token)
      else
        $scope.factivaLogin.busy = false
        $scope.factivaLogin.status = "Access to Dow Jones Factiva results is not permitted for this account." +
                                     " " +
                                     "Please contact your account manager."
      return
    ).error((data, status, headers, config) ->
      $scope.factivaLogin.busy = false
      factiva_error = data.Error.Message
      if factiva_error
        $scope.factivaLogin.status = "Message from Dow Jones Factiva: " + data.Error.Message
      else
        $scope.factivaLogin.status = "An unknown error occurred while contacting Dow Jones Factiva." +
                                     " " +
                                     "Please try again. If this error persists, please contact your account manager."
      return
    )

    return

  # Send the EncryptedToken to Arachnys
  $scope.sendToken = (token) ->
    $scope.factivaLogin.busy = true
    $scope.factivaLogin.status = "Authenticating with Arachnys."
    $http.put(endpoints.FactivaToken,
      "factiva_token": token
    ).success((data, status, headers, config) ->
      factivaAuthenticationSuccess = true
      $uibModalInstance.close factivaAuthenticationSuccess
      return
    ).error((data, status, headers, config) ->
      $scope.factivaLogin.busy = false
      $scope.factivaLogin.status "An unknown error occurred while contacting Arachnys." +
                                 " " +
                                 "Please try again." +
                                 " " +
                                 "If this error persists, please contact your account manager."
      return
    )
